import { DayEndReport } from './types';

/** Calendar labels are local to the viewer; recorded closing dates retain their schedule zone. */
export function closingDays(from: string, to: string, groups: NonNullable<DayEndReport['dailyGroups']>) {
  const dates = new Set(groups.map((row) => row.date));
  const cursor = new Date(from),
    end = new Date(Date.parse(to) - 1);
  cursor.setHours(0, 0, 0, 0);
  for (let count = 0; count < 32 && cursor <= end; count++) {
    dates.add(
      `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, '0')}-${String(cursor.getDate()).padStart(2, '0')}`,
    );
    cursor.setDate(cursor.getDate() + 1);
  }
  const byDate = new Map(groups.map((row) => [row.date, row]));
  return [...dates].sort().map((date) => ({ date, counts: byDate.get(date) }));
}
